var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('van-divider',{style:({
      color: '#555',
      borderColor: '#555',
      padding: '0 16px',
      fontSize: '15px',
    })},[_vm._v("حابارلاسۋ جولى")]),_c('p',[_vm._v(" قۇرمەتتى پايدالانۋشى: مايرا ساباقحاناسىن پايدالانۋ بارىسىندا كەزىككەن ماسەلەلەرىڭىز بولسا باعدارلاما جاۋاپتىسمەن قابارلاسساڭىزدار بولادى. ەگەردە ساباقحاناعا قاتىسسىز سۇراقتارىڭىز بولسا مازالاماڭىزدار. راحىمەت! ")]),_c('img',{staticClass:"qrCode",attrs:{"src":require("../../assets/musa.jpg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }